module.exports = __webpack_public_path__ + "components/outside-promo-page/static/logo-a86c81d4dfd7470916e3798d9f970688.svg";